@import "../scss/vars.scss";
.x-sd-checker-box {
  padding: 0;
  margin-left: 0px;
  margin-right: 4px;
  transform: translateY(0px);
}
.x-search-drop-down {
  position: relative;
  z-index: 2;
  display: flex;
  &.x-sd-multi {
    .dna-dd-item {
      position: relative;
      cursor: default;
      align-items: center;
    }
  }

  .dna-center-flex {
    .md-dd-content {
      transform: translateY(0px);
    }
  }
  .dna-flex {
    .md-dd-content {
      transform: translateY(1px);
    }
  }

  .dna-middle-flex {
    input[type="checkbox"] {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  &.has-clear-icon {
    z-index: 1;

    input:not([type="checkbox"]) {
      padding-right: 50px;
      position: relative;
      z-index: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  // The clear icon sits where the caret was, so hide the caret and give the text the space back
  &.x-sd-clear-visible {
    .x-dd-dd-dd-icon {
      display: none;
    }
    input:not([type="checkbox"]) {
      padding-right: 30px;
    }

    + .dna-search-dd-clear {
      right: 7px;
    }
  }
}

.dna-search-dd-clear {
  position: absolute;
  z-index: 999999999999;
  width: 20px;
  height: 20px;
  right: 31px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
  @include bg05;
  cursor: pointer;
  display: flex !important;
  justify-content: center;
  align-items: center;
  transition: all 0.4s;

  pointer-events: all;
  line-height: 20px;
  svg {
    pointer-events: none;

    font-size: 12px;
    transform: translateY(2px);
  }
  &:hover {
    background-color: red;
    color: white;
    opacity: 1;
    transform: translateY(-50%) scale(1.2);
    svg {
      opacity: 1;
    }
  }

  .x-field-orange & {
    svg {
      color: white;
    }
    background-color: rgba(white, 0.2);
  }
}

.x-field-mint {
  .x-dd-dd-dd-icon {
    svg {
      color: #111 !important;
    }
  }
}

.x-field-mint {
  .dna-search-dd-clear {
    svg {
      color: #111;
    }
  }
}

.dna-disabled,
.dna-disable {
  .dna-search-dd-clear {
    pointer-events: none;
  }
}
